export const COGENTROLES = Object.freeze({
    STAFF: 1,
    PRINCIPLE: 2,
    HOD: 3,
    STUDENT: 1108
});


export const PROFILESTATUS = Object.freeze({
    UN_VERIFIED: 0,
    VERIFIED: 1,
    UPDATED: 2,
    REJECTED: 3,
    BLOCKED: 4
});

export const GOVANNOUNCEMENT_STATUS = Object.freeze({
    INACTIVE: 0,
    ACTIVE: 1
});

export const GOVANNOUNCEMENT_STATUS_OPTIONS = [
    { value: GOVANNOUNCEMENT_STATUS.INACTIVE, label: "InActive" },
    { value: GOVANNOUNCEMENT_STATUS.ACTIVE, label: "Active" }
];

export const OS_TYPE_OPTIONS = [
    { value: 1, label: "ANDROID" },
    { value: 2, label: "IOS" }
];
